var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_128_43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.2477 40.8987H34.0865V29.7605C34.0865 27.1045 34.0388 23.6854 30.3619 23.6854C26.6321 23.6854 26.0614 26.5792 26.0614 29.5672V40.898H18.9001V17.9933H25.7749V21.1235H25.8712C26.5592 19.9552 27.5534 18.994 28.7479 18.3425C29.9424 17.6909 31.2924 17.3734 32.6543 17.4236C39.9125 17.4236 41.2508 22.1651 41.2508 28.3336L41.2477 40.8987ZM10.8198 14.8624C9.99791 14.8625 9.19437 14.6206 8.51088 14.1672C7.82738 13.7138 7.29465 13.0693 6.97997 12.3152C6.6653 11.561 6.58283 10.7312 6.74303 9.93052C6.90324 9.12986 7.29892 8.39436 7.88001 7.81704C8.4611 7.23971 9.20152 6.84648 10.0076 6.68708C10.8137 6.52768 11.6493 6.60927 12.4088 6.92152C13.1682 7.23378 13.8173 7.76268 14.2741 8.44134C14.7308 9.12 14.9747 9.91795 14.9749 10.7343C14.975 11.2763 14.8676 11.813 14.6588 12.3138C14.4501 12.8146 14.1441 13.2697 13.7582 13.653C13.3724 14.0363 12.9143 14.3404 12.4101 14.5479C11.906 14.7554 11.3656 14.8623 10.8198 14.8624ZM14.4005 40.8987H7.23175V17.9933H14.4005V40.8987ZM44.8179 0.00278204H3.63324C2.69846 -0.00769485 1.79769 0.350839 1.12894 0.999596C0.460198 1.64835 0.0781809 2.53426 0.0667725 3.46264V44.5357C0.0777904 45.4645 0.459583 46.351 1.12831 47.0005C1.79703 47.6499 2.698 48.0091 3.63324 47.9992H44.8179C45.755 48.0109 46.6585 47.6527 47.3299 47.0033C48.0013 46.3539 48.3856 45.4664 48.3986 44.5357V3.45968C48.3852 2.52945 48.0006 1.64254 47.3292 0.9938C46.6578 0.345058 45.7546 -0.0124511 44.8179 -0.000182638",
    fill: "#0A66C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_128_43"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.72bea40f772adb0e74d4bb8f56358e89.svg";
export { ForwardRef as ReactComponent };